<data-loader
  *ngIf="!courierPrices.length; else showCourierPrices"
  [msg]="'Loading couriers...'"
></data-loader>

<ng-template #showCourierPrices>
  <div class="large-form-container">
    <div [ngSwitch]="viewPreference">
      <app-table-view
        *ngSwitchCase="'tableView'"
        [courierPrices]="courierPrices"
        [courierPartnerForm]="courierPartnerForm"
        (courierPartnerValue)="setCourierPartnerValue($event)"
        (showShippingChargeInfo)="shippingInfo($event)"
      ></app-table-view>

      <app-card-view
        *ngSwitchCase="'cardView'"
        [courierPrices]="courierPrices"
        [courierPartnerForm]="courierPartnerForm"
        (courierPartnerValue)="setCourierPartnerValue($event)"
        (showShippingChargeInfo)="shippingInfo($event)"
      ></app-card-view>
    </div>
  </div>
</ng-template>
